"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GKButtonRow = void 0;
var React = __importStar(require("react"));
var common_1 = require("../../common");
var hooks_1 = require("../../common/hooks");
var __1 = require("../..");
require("./GKButtonRow.css");
/**
 * A component to standardize button layout and mobile/desktop styles when
 * multiple buttons are present. Provides sane defaults, but allows the user to
 * set alignment and the breakpoint at which buttons transition between mobile
 * and desktop styles. An optional border can be added when needed.
 */
var GKButtonRow = function (props) {
    var _a;
    var _b = props.align, align = _b === void 0 ? "right" : _b, _c = props.inlineBreakpoint, inlineBreakpoint = _c === void 0 ? __1.Breakpoint.MD : _c, topBorder = props.topBorder, otherProps = __rest(props, ["align", "inlineBreakpoint", "topBorder"]);
    var displayClass = (0, hooks_1.useResponsive2)((_a = {},
        _a[inlineBreakpoint] = "inline",
        _a));
    var textClass = "text-" + (inlineBreakpoint !== __1.Breakpoint.XS ? inlineBreakpoint + "-" + align : align);
    var passthruProps = (0, common_1.mapDefaultProps)(otherProps, {
        _gkComponentName: "gk-button-row",
        className: textClass + " " + displayClass + (topBorder ? " border-top" : ""),
    });
    return React.createElement("div", __assign({}, passthruProps));
};
exports.GKButtonRow = GKButtonRow;
exports.default = exports.GKButtonRow;
